
export const API_RELATIVE_URI = {
    // Subject
    SUBJECTS_TREE: 'subject/subjects-tree',
    LISTED_SUBJECTS: 'subject/listed-subjects',
    LISTED_CHAPTERS: 'subject/listed-chapters',
    ADD_SUBJECT: 'subject/add-subject',
    UPDATE_SUBJECT: 'subject/update-subject',
    DELETE_SUBJECT: 'subject/delete-subject',

    // Chapter
    ADD_CHAPTER: 'subject/add-chapter',
    UPDATE_CHAPTER: 'subject/update-chapter',
    DELETE_CHAPTER: 'subject/delete-chapter',

    // Role
    PAGINATED_ROLES: 'role/paginated-roles',
    LISTED_ROLES: 'role/listed-roles',
    ROLE: 'role',
    ADD_ROLE: 'role/add',
    UPDATE_ROLE: 'role/update',
    DELETE_ROLE: 'role/delete',

    // User
    PAGINATED_USERS: 'user/paginated-users',
    LISTED_USERS: 'user/listed-users',
    USER: 'user',
    MY_PROFILE: 'user/my-profile',
    ADD_USER: 'user/add',
    UPDATE_USER: 'user/update',
    UPDATE_USER_PROFILE: 'user/update-profile',
    DELETE_USER: 'user/delete',
    LOG_IN: 'user/log-in',
    CHANGE_SELF_PASSWORD: 'user/change-self-password',
    CHANGE_OTHER_PASSWORD: 'user/change-other-password',

    // Student
    PAGINATED_STUDENTS: 'student/paginated-students',
    STUDENT: 'student',
    STUDENT_MY_PROFILE: 'student/my-profile',
    REGISTER_STUDENT: 'student/register',
    SELF_REGISTER_STUDENT: 'student/self-register',
    STUDENT_LOGIN: 'student/login',
    SELECT_TENANT: 'student/select-tenant',
    GOOGLE_AUTH: 'student/google-auth',
    GOOGLE_REGISTER: 'student/google-register',
    UPDATE_STUDENT: 'student/update',
    UPDATE_STUDENT_PROFILE: 'student/update-profile',
    DELETE_STUDENT: 'student/delete',
    CHANGE_STUDENT_PASSWORD: 'student/change-password',

    // Pricing Plan
    PRICING_PLANS: 'pricing-plan/plans',
    PRICING_PLAN: 'pricing-plan/plan',
    ADD_PRICING_PLAN: 'pricing-plan/add',
    UPDATE_PRICING_PLAN: 'pricing-plan/update',
    DELETE_PRICING_PLAN: 'pricing-plan/delete',

    // Course
    LISTED_COURSES: 'course/listed-courses',
    LISTED_COURSES_SHORT: 'course/listed-courses-short',
    COURSE_WITH_ITEMS: 'course/course-with-items',
    GET_COURSE: 'course',
    ADD_COURSE: 'course/add-course',
    UPDATE_COURSE: 'course/update-course',
    DELETE_COURSE: 'course/delete-course',
    GET_COURSE_ITEM: 'course/course-item',
    ADD_COURSE_ITEM: 'course/add-course-item',
    UPDATE_COURSE_ITEM: 'course/update-course-item',
    DELETE_COURSE_ITEM: 'course/delete-course-item',

    // Student Courses
    COURSE_CATALOG: 'course/catalog',
    STUDENT_ACTIVE_COURSES: 'course/student-active-courses',
    STUDENT_COURSE_WITH_ITEMS: 'course/student-course-with-items',
    ADD_COURSE_ITEM_STUDENT_PROGRESS: 'course/add-course-item-student-progress',
    SUBMIT_QUIZ_ANSWERS: 'course/submit-quiz-answers',

    // Questions Bank
    PAGINATED_QUESTIONS_BANKS: 'questions-bank/paginated-questions-banks',
    LISTED_QUESTIONS_BANKS: 'questions-bank/listed-questions-banks',
    LISTED_QUESTIONS_BANKS_BY_SUBJECT_ID: 'questions-bank/listed-questions-banks-by-subject-id',
    QUESTIONS_BANK: 'questions-bank',
    ADD_QUESTIONS_BANK: 'questions-bank/add',
    UPDATE_QUESTIONS_BANK: 'questions-bank/update',
    DELETE_QUESTIONS_BANK: 'questions-bank/delete',

    // Question
    PAGINATED_QUESTIONS: 'question/paginated-questions',
    QUESTION: 'question',
    ADD_QUESTION: 'question/add',
    ADD_QUESTIONS_BATCH: 'question/add-batch',
    UPDATE_QUESTION: 'question/update',
    DELETE_QUESTION: 'question/delete',

    // YouTube
    YOUTUBE_CHANNEL_VIDEOS: 'youtube-service/channel-videos',
    YOUTUBE_VIDEO_DETAILS: 'youtube-service/video-details',
    YOUTUBE_VIDEO_STREAM_INFO: 'youtube-service/video-stream-info',

    // Documents/Video (Bunny-backed) - Route: api/documents, api/videos
    UPLOAD_DOCUMENT: 'documents/upload',
    DELETE_DOCUMENT: 'documents',
    CREATE_VIDEO_UPLOAD_SESSION: 'videos/upload-session',
    DELETE_VIDEO: 'videos',
    VIDEO_PREVIEW_URL: 'videos',

    // Exam
    PAGINATED_EXAMS: 'exam/paginated-exams',
    LISTED_EXAMS: 'exam/listed-exams',
    EXAM: 'exam',
    EXAM_FULL_QUESTIONS: 'exam/full-questions',
    GET_EXAM_QUESTIONS_BY_CRITERIA: 'exam/paginated-questions-by-criteria',
    RANDOM_EXAM_QUESTIONS: 'exam/random-exam-questions',
    ADD_EXAM: 'exam/add',
    ADD_EXAM_FROM_IMPORTED_QUESTIONS: 'exam/add-from-imported-questions',
    COPY_EXAM: 'exam/copy',
    UPDATE_EXAM: 'exam/update',
    DELETE_EXAM: 'exam/delete',

    // Student Exams
    EXAM_CATALOG: 'exam/catalog',
    STUDENT_ACTIVE_EXAMS: 'exam/student-active-exams',
    STUDENT_EXAM_WITH_QUESTIONS: 'exam/student-exam-with-questions',
    SUBMIT_EXAM_ANSWERS: 'exam/submit-exam-answers',

    // License
    PAGINATED_LICENSES: 'license/paginated-licenses',
    LICENSE_STUDENTS: 'license/license-students',
    GRANT_LICENSE_TO_STUDENTS: 'license/grant-license-to-students',
    REVOKE_LICENSE_FOR_STUDENT: 'license/revoke-license-for-student',
    UPDATE_LICENSE_STATUS: 'license/update-license-status',
    DELETE_LICENSE: 'license/delete-license',

    // Dashboard Statistics
    ADMIN_DASHBOARD_STATISTICS: 'dashboard-statistics/admin',
    STUDENT_DASHBOARD_STATISTICS: 'dashboard-statistics/student',
    USER_DASHBOARD_STATISTICS: 'dashboard-statistics/user',

    // Student Results
    PAGINATED_STUDENT_RESULTS: 'student-results/paginated-results',
    STUDENT_RESULT_DETAILS: 'student-results/student',
    EXAM_ATTEMPT_ANSWERS: 'student-results/exam-attempt-answers',
    MY_EXAM_ATTEMPTS: 'student-results/my-exam-attempts',
    MY_EXAM_ATTEMPT_ANSWERS: 'student-results/my-exam-attempt-answers',
    EXPORT_EXAM_RESULTS_CSV: 'student-results/export-exam-results-csv',

    // Live Rooms
    PAGINATED_LIVE_ROOMS: 'live-rooms/paginated',
    ASSIGNED_LIVE_ROOMS: 'live-rooms/assigned',
    LIVE_ROOM_BY_ID: 'live-rooms',
    ADD_LIVE_ROOM: 'live-rooms/add',
    UPDATE_LIVE_ROOM: 'live-rooms/update',
    DELETE_LIVE_ROOM: 'live-rooms/delete',
    MANAGE_LIVE_ROOM_STUDENT_ASSIGNMENTS: 'live-rooms/manage-student-assignments',
    LIVE_ROOM_ASSIGNED_STUDENTS: 'live-rooms/assigned-students',
    LIVE_ROOM_ACCESS_TOKEN: 'live-rooms/token',
    LIVE_ROOM_ATTENDANCE_JOIN: 'live-rooms/attendance/join',
    LIVE_ROOM_ATTENDANCE_LEAVE: 'live-rooms/attendance/leave',
    LIVE_ROOM_ATTENDANCE: 'live-rooms/attendance',
    LIVE_ROOM_ATTENDANCE_PAID_STATUS: 'live-rooms/attendance/paid-status',
    LIVE_ROOM_ATTENDANCE_COST: 'live-rooms/attendance/cost',

    // Attendance
    ATTENDANCE_TODAY_SESSION: 'attendance/today-session',
    ATTENDANCE_MARK: 'attendance/mark',
    ATTENDANCE_CHECK_IN: 'attendance/check-in',
    ATTENDANCE_STUDENT_HISTORY: 'attendance/student-history',
    ATTENDANCE_SEARCH_STUDENT_BY_EMAIL: 'attendance/search-student-by-email',
    ATTENDANCE_EXPORT_CSV: 'attendance/export-csv',

    // Financial Reports
    FINANCIAL_REPORTS_SUMMARY: 'financial-reports/summary',
    PAGINATED_FINANCIAL_CHARGES: 'financial-reports/paginated-charges',

    // Parent Notifications (WhatsApp reports)
    SEND_EXAM_RESULT_REPORT: 'parent-notification/send-exam-result',
    SEND_COURSE_PROGRESS_REPORT: 'parent-notification/send-course-progress',
    SEND_ATTENDANCE_REPORT: 'parent-notification/send-attendance-summary',

    // Tenant Settings (self-service, tenant admin)
    TENANT_SETTINGS_BRANDING: 'tenant-settings/branding',
    TENANT_SETTINGS_INTEGRATIONS: 'tenant-settings/integrations',
    TENANT_SETTINGS_PAYMENT_CHANNELS: 'tenant-settings/payment-channels',

    // Platform Admin
    PLATFORM_ADMIN_LOG_IN: 'platform/auth/log-in',
    PLATFORM_ADMIN_SELECT_TENANT: 'platform/auth/select-tenant',

    // Public
    PUBLIC_MEDIA_UPLOAD_LIMITS: 'public/media-upload-limits',
    PUBLIC_TENANT_INFO: 'public/tenant-info',

    // AI
    AI_GENERATE_QUESTIONS: 'ai/generate-questions',
    AI_EXTRACT_EXAM_QUESTIONS: 'ai/extract-exam-questions',
    AI_TOOLS: 'ai/tools',
    AI_CHAT: 'ai/chat',

    // Notification
    NOTIFICATIONS_MINE: 'notification/mine',
    NOTIFICATIONS_UNREAD_COUNT: 'notification/unread-count',
    NOTIFICATIONS_MARK_READ: 'notification/mark-read',
    NOTIFICATIONS_MARK_ALL_READ: 'notification/mark-all-read',

    // Enrollment
    ENROLLMENT_PAYMENT_CHANNELS: 'enrollment/payment-channels',
    PAGINATED_ENROLLMENT_REQUESTS: 'enrollment/paginated-requests',
    PENDING_ENROLLMENT_REQUESTS_COUNT: 'enrollment/pending-requests-count',
    REQUEST_ENROLLMENT: 'enrollment/request',
    CANCEL_ENROLLMENT_REQUEST: 'enrollment/cancel-request',
    ENROLL_FREE_RESOURCE: 'enrollment/enroll-free',
    CANCEL_ENROLLMENT: 'enrollment/cancel-enrollment',
    RESPOND_TO_ENROLLMENT_REQUEST: 'enrollment/respond-to-request',
} as const;